import { httpPost } from "../remoteDataProvider"

export async function exportProfileDataTemplate(payload: any, token: string) {
  console.log("payload", JSON.stringify(payload))
  const { data } = await httpPost("people_flow_import_export", "/data-export/profile-data-template", payload, token)
  if (data.result !== "success") {
    throw { code: "UnknownExportError" }
  }
  return data
}
